module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-SCC.4d165352.png";